<template lang="pug">
.body-edit-profile
  div.modal-header
    span.edit-modal-title THAY ĐỔI THÔNG TIN CÁ NHÂN
    span.edit-modal-btn-close.material-icons(@click="$emit('close')") close
  div.modal-body
    .alert.alert-danger(v-if='error') {{error}}
    form(action='#' autocomplete='off' method='post')
      .row
        .col-md-12(v-if="socialType === 1")
          md-fg-input(label='Tên đăng nhập *', :labelFloating='false', type='text', v-model='user.username' :disabled='true')
        .col-md-12
          //- md-fg-input(label='Tên hiển thị *', :labelFloating='false', type='text', v-model='fullName' :required='true')
          .form-group.custom-form-group(:class="[isSubmitStep && fullName.length  === 0 ? 'error' : '']")
            label.control-label Tên hiển thị *
            input.form-control#fullname(type='text', v-model='fullName', required maxlength=125)
        .col-md-12
          md-fg-input(
            label='Giới thiệu ngắn về bản thân'
            autocomplete='off'
            :labelFloating='false'
            type='textarea'
            v-model='userQuotes'
            :count='true'
            :countCharacter="totalcharacter"
            maxlength='160'
            @input="getInputArea")
        .col-md-6
          md-fg-input(label='Màu tên hiển thị *', :labelFloating='false', type='color', v-model='user.name_color')
        .col-md-12
          md-fg-input(label='Email *'
            :labelFloating='false'
            v-model='user.email'
            :checkbox='true'
            :isChecked='user.is_show_email'
            name="email"
            @getCheckBox="getCheckBox"
            :disabled='true')
        .col-md-12
          //- md-fg-input(
          //-   label='Số điện thoại'
          //-   :labelFloating='false'
          //-   :checkbox='true'
          //-   :isChecked='user.is_show_phone'
          //-   @getCheckBox="getCheckBox"
          //-   name="phone_number"
          //-   v-model='phoneNumber')
          .form-group.custom-form-group(:class="[isSubmitStep && phoneNumber.length  === 0 ? 'error' : '']")
            label.control-label Số điện thoại
              span(style="float: right;")
                table
                  tr
                    td
                      input(type="checkbox" @click='getPhone' :checked="user.is_show_phone ? true : false")
                    td Hiển thị với mọi người
            input#phoneID.form-control(type="text" ref="phoneID"
              name="phone_number" 
              autocomplete="off" 
              dir="ltr"
              v-model='phoneNumber'
              maxlength = 10 
              @keypress="isAllow")

        .col-md-12
          md-fg-input(
            label='Ngày sinh của bạn'
            :labelFloating='false'
            v-model='birthDay'
            name="birthday"
            @getCheckBox="getCheckBox"
            :checkbox='true'
            :isChecked='user.is_show_birthday'
            type="date"
            :class="[isSubmitStep && isDate ? 'error' : '']")
          small.required(v-if="isDate") Ngày sinh không được là ngày trong tương lai
      .row
        .edit-modal-school(
          :class="user.type_user === 1 ? 'col-md-9' : 'col-md-12'" 
          :style="user.type_user !== 1 ? 'padding-right: 15px;' : ''"
        )
          .form-group.custom-form-group
            label.control-label Chọn trường học
            select#school_id.form-control(v-model="currentSchoolID" @change='onChangeSchool($event)' required)
              option(v-for='(o, index) in schools' :value='o.id') {{o.name}}
        .col-md-3.col-xs-5(v-if="user.type_user === 1")
          .form-group.custom-form-group
            label.control-label Chọn khối lớp
            itemGrade(
              :selected_school_id="isSelectedSchool ? selectedSchool : user.school_id"
              :grade_id='currentGradeID'
              :grades='grades'
              :schools='schools'
              @onGradeChange="onGradeChanged")
      
  div.modal-footer.profile-custom-footer
    .row.text-center
      button.edit-btn-save.btn(@click='submitFormEdit') Lưu thay đổi
    .row.col-md-6.text-left(v-if="socialType === 1")
      a.link-change-pass(href='#' @click='openChangePassword()') Đổi mật khẩu mới
</template>

<script>
import gql from 'graphql-tag'
import itemGrade from './itemGrade'
import mdChangePassword from './changePassword'
import graphql from '../Model/graphql'
// import $ from 'jquery'
import moment from 'moment'
import MdNotification from '@/core/components/mdNotification'

export default {
  name: 'modalUpdateProfile',
  components: {
    itemGrade,
    mdChangePassword,
    MdNotification
  },
  props: {
    saveEditProfile: Function,
    quotesLength: Number,
    user: Object
  },
  data() {
    return {
      error: null,
      isDate: false,
      isSelectedSchool: false,
      grades: [],
      schools: [],
      selectedSchool: Number,
      selectedGrade: null,
      totalcharacter: this.quotesLength > 0 ? this.quotesLength : 0,
      is_show_email: null,
      is_show_phone: null,
      is_show_birthday: null,
      fullName: this.user.fullname,
      userQuotes: this.user.userquotes,
      phoneNumber: this.user.phone_number,
      birthDay: this.user.birthday,
      currentSchoolID: this.user.school_id,
      currentGradeID: this.user.grade_id,
      socialType: this.user.social_type,
      isSubmitStep: false
    }
  },
  methods: {
    // Hiện thông báo
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    getInputArea(event) {
      this.totalcharacter = event.length
    },
    getPhone(event) {
      // console.log(event.target.checked)
      this.is_show_phone = event.target.checked
    },
    checkDate() {
      this.isDate = false
      var date1 = new Date()
      date1 = moment(date1)
      var date2 = moment(this.birthDay)
      if (date1 < date2) {
        this.isDate = true
      }
    },
    isAllow(event) {
      var key = window.event ? event.keyCode : event.which
      if (event.keyCode === 8 || event.keyCode === 46) {
        return true
      } else if (key < 48 || key > 57) {
        event.preventDefault()
        return false
      } else {
        return true
      }
    },
    getCheckBox(data) {
      if (data) {
        if (data[0] === 'email') {
          this.is_show_email = data[1]
        } else if (data[0] === 'phone_number') {
          this.is_show_phone = data[1]
        } else if (data[0] === 'birthday') {
          this.is_show_birthday = data[1]
        }
      }
    },
    onChangeSchool(e) {
      var index = e.target.value
      // var name = e.target.options[e.target.options.selectedIndex].text
      this.isSelectedSchool = true
      this.selectedSchool = parseInt(index)
    },
    checkForm() {
      if (this.fullName === null || this.fullName === '') {
        this.showNotification('Vui lòng nhập tên hiển thị', 'warning', 'top', 'right', 2000)
        this.error = 'Vui lòng nhập tên hiển thị'
        this.isSubmitStep = true
        return false
      } else if (this.phoneNumber.length === 0) {
        this.showNotification('Vui lòng nhập số điện thoại', 'warning', 'top', 'right', 2000)
        this.error = 'Vui lòng nhập số điện thoại.'
        this.isSubmitStep = true
        return false
      } else if (this.isDate) {
        this.showNotification('Ngày sinh không được là ngày trong tương lai', 'warning', 'top', 'right', 2000)
        this.error = 'Ngày sinh không được là ngày trong tương lai'
        this.isSubmitStep = true
        return false
      } else {
        this.isSubmitStep = false
        this.error = null
        return true
      }
    },
    submitFormEdit() {
      // console.log('Submit Edit Form')
      this.checkDate()
      if (!this.isDate) {
        if (!this.checkForm()) {
          return
        }
        this.saveEditProfile({
          uid: this.user.id,
          fullname: this.fullName,
          userquotes: this.userQuotes,
          phone_number: this.phoneNumber,
          name_color: this.user.name_color,
          school_id: this.currentSchoolID,
          birthday: this.birthDay,
          grade_id: this.selectedGrade !== null ? this.selectedGrade : this.currentGradeID,
          is_show_email: this.is_show_email !== null ? this.is_show_email : this.user.is_show_email,
          is_show_phone: this.is_show_phone !== null ? this.is_show_phone : this.user.is_show_phone,
          is_show_birthday: this.is_show_birthday !== null ? this.is_show_birthday : this.user.is_show_birthday
        })
        this.$nextTick(() => {
          this.$emit('close')
        })
      }
    },
    onGradeChanged(id) {
      if (id) this.selectedGrade = parseInt(id)
    },
    openChangePassword() {
      // close pop-up edit profile
      this.$emit('close')
      try {
        this.$modal.show(mdChangePassword, {
          user: this.user
        }, {
          // width: '43%',
          height: 'auto',
          classes: ['col-md-6', 'col-12'],
          adaptive: true,
          resize: true,
          scrollable: true,
          clickToClose: false,
          reset: true,
          pivotY: 0.5 // vertial position(0-1.0)
        })
      } catch (e) {
        console.error(e)
      }
    }
  },
  apollo: {
    grades: {
      query: gql(graphql.GET_GRADES),
      update: data => {
        return data.grades
      }
    },
    schools: {
      query: gql(graphql.GET_SCHOOLS),
      update: data => data.school
    }
  }
  // update () {
  //   if (window.innerWidth < 991) {
  //     this.$refs['phoneID'].scrollIntoView()
  //   }
  // }
}
// if (window.innerWidth < 991) {
//   $(document).on('focus', 'input#phoneID', function() {
//     document.querySelector('input#phoneID').scrollIntoView()
//   })
// }
</script>

<style lang="scss">
:root {
  // Color 
  --color-background-button: #FFD311;
}
.v--modal-overlay.scrollable{z-index: 10;}
.body-edit-profile {
  // margin-left: 5px;
  // margin-right: 5px;
  background-color: white;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px;
  .form-group{
    &.error{
      input, select{border: 1px solid #f00;}
      span.required{display: block; color: #f00; text-align: left;}
    }
  }
  .edit-modal-title {
    // font-weight: bold;
    font-family: 'Helvetica', sans-serif;
    float: left;
    font-size: 17px;
  }
  .edit-modal-school {
    padding-right: 0;
  }
  .edit-modal-btn-close {
    float: right;
    &:hover {
      cursor: pointer;
    }
  }
  small.required{display: block; color: #f00;}
  .edit-btn-save {
    background: var(--color-background-button);
    color:black;
    text-transform: none;
    font-size: 13px;
    font-family: 'adobe-clean', sans-serif;
    border: 1px solid #FFD311;
    border-radius: 5px;
    box-shadow: 0px 0px 0px;
    margin-top: 0 !important;
    width: 160px;
  }
  .link-change-pass {
    color: #1A0DAB;
    font-size: 14px;
    font-family: 'adobe-clean', sans-serif;
    text-decoration: underline;
    // &:hover {
    //   text-decoration: underline;
    // }
  }
  .profile-custom-footer {
    padding-top: 0;
    border: 0;
  }
}
@media (max-width: 414px) {
  .body-edit-profile {
    .edit-modal-school {
      padding-right: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// UpdateProfile.vue?723fd660